 <template>
    <div style="background:white" class="ve-list-page">
        <div style=" background:white;line-height:30px;border-bottom:2px solid #389"> 
            <div style="padding-top:3px;display:flex;width:1400px; ">
                <span style="  font-size:12px;margin-right:10px;margin-left:5px">{{ $LANG('0681', '字段查询') }}</span>
                <el-select @change="selChg" v-model="selparam" size="small" :placeholder="$LANG('1675', '请选择列名')" filterable  style="width:130px; " >
                    <span v-for="item in tabCol" :key='item.key'>
                        <el-option :label="item.title" :value="item.key" v-if="item.thide=='N' "></el-option>
                    </span>
                </el-select>

                <el-input v-if="v_bool" :placeholder="input_hold" clearable v-model="txtparam" @keyup.enter.native="qryTabData" size="small" style="width:320px; height:30px; ">
                    <el-select v-model="oper" slot="prepend"   style="width:100px;background:white;border:1px solid #389 " >
                        <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                        </span>
                    </el-select>
                    <template slot ="append">
                        <el-button size="small" slot="append" icon="iconfont icon-gaojichazhao2" @click="qryTabData" class="custom-button" ></el-button>
                    </template>
                </el-input> 
                <el-date-picker @change="qryTabData" style="width:300px" size="small" value-format="yyyy-MM-dd" v-if="!v_bool"  v-model="txtArr1" type="daterange" :range-separator="$LANG('1657', '至')" :start-placeholder="$LANG('0021', '开始日期')"  :end-placeholder="$LANG('0913', '结束日期')">  </el-date-picker>
                <span style="font-weight:600;color:#409eff;font-size:12px;margin-right:10px;margin-left:15px">{{ $LANG('0545', '产品状态') }}</span>
                <el-select @change="stfgChg"  v-model="t_stfg" size="small"  style="width:100px; " >                
                    <el-option :label="$LANG('0040', '所有记录')" value="ALL" ></el-option>
                    <el-option :label="$LANG('2004', '未完成')" value="N" ></el-option>
                    <el-option :label="$LANG('1974', '已完成')" value="Y" ></el-option>
                </el-select>
                <el-dropdown @command="dropSel"   size="small" style="margin-left:20px;">
                    <el-button type="danger" size="small" style="height:31px">
                        {{ $LANG('0337', '更多') }}<i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown"  >
                        <el-dropdown-item icon="iconfont icon-daochu" command="expdata" style="line-height:40px;height:40px">{{ $LANG('0172', '导出数据') }}</el-dropdown-item>
                        <el-dropdown-item icon="iconfont icon-ziyuan" command="fldset" style="line-height:40px;height:40px">{{ $LANG('0683', '字段设置') }}</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
        <div class="ve-list-page__table">
        <ve-table :columns="vueCol" 
                :table-data="tabData" 
                :columnHiddenOption="columnHiddenOption"
                style="margin-top:2px; "
                :border-around="true"
                :border-x="true" 
                :border-y="true" 
                :fixed-header="true"
                row-key-field-name="PKSEQ"
                :row-style-option="rowStyleOption"
                :cell-style-option="cellStyleOption"
                :max-height="subHeight" 
                
                :scroll-width="0"
                :footer-data="footerData"
                :clipboardOption="{copy:true,paste:false,cut:false,delete:false}"
                :virtual-scroll-option="virtualScrollOption"
                :column-width-resize-option="columnWidthResizeOption"
                :cellSelectionOption="{enable: false,}"
                id="loading-ordpro"
                ref="tableRef"            >
        </ve-table>
        </div>
        <div style="margin-top:2px" class="ve-list-page__pagination">
            <ve-pagination
                :total="dataCount"
                :page-index="pageIndex"
                :page-size="pageSize"
                :page-size-option="pageList"
                @on-page-number-change="pageNumberChange"
                @on-page-size-change="pageSizeChange"
            />
        </div>
        <!-- 提示框 -->
        <el-dialog :show-close="false" v-dialogDrag :visible.sync="promptWin" width="400px" append-to-body :close-on-click-modal="false" :close-on-press-escape="false" >
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'35px'}">
                <span style="line-height:35px;height:35px;font-size:14px;padding-left:5px;">{{ $LANG('1442', '提示') }}</span>
            </div>
            <div style="line-height:30px;display:flex">
                <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
            </div>
            <div slot="footer">
                <Button type="primary"   @click="promptWin=false" style="margin-right:20px;">{{ $LANG('1638', '确定') }}</Button>
            </div>
        </el-dialog>
 
        <!-- 明细资料 -->
        <el-dialog class="pub_dialog" v-dialogDrag   :visible.sync="dtlWin" width="1200px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:36px;height:36px;font-size:15px;padding-left:5px;"><i class="iconfont icon-xuanze" style="margin-right:5px"></i>{{$route.meta.title}} ：{{ $LANG('0109', '明细资料') }}</span>
            </div> 
            <div style=" overflow-y:auto;margin-top:-8px">
                <div class="one-div" style="height:31px">
                    <div class="oneRow" style="display:flex;">
                        <div style="font-size:14px;color:#ff0000">{{ dtlTitle }}</div>
                        <el-button type="danger"   icon="iconfont icon-xinzeng" @click="addRec" size="mini" style="margin-left:25px;height:30px">{{ $LANG('0095', '新增记录') }}</el-button>
                        <el-button type="primary"   icon="iconfont icon-fuzhi" @click="copyData" size="mini" style="margin-left:35px;height:30px">{{ $LANG('0166', '复制表格') }}</el-button>
                    </div>
                </div>            
                <el-table  :data="dtlData" 
                    border                            
                    size="small"
                    cell-class-name="clearPadding"
                    :header-cell-style="{ 'color':'#389','text-align':'center'}"
                    :cell-style="{padding:'3px',color:'black','font-size':'12px'}"
                    header-cell-class-name="clearPadding"
                    :row-class-name="tabRowClass" 
                    :row-key="getRowKey"
                    show-summary
                    :summary-method="getDtlSummary"
                    class="custom-table-border"
                    ref="refdtl"
                    height="500px" 
                    highlight-current-row
                    style="overflow:auto;margin-top:-9px;"> 
                    <el-table-column :label="$LANG('0310', '序号')" type="index" width="60" fixed> </el-table-column>
                    <el-table-column   v-for="(item,index ) in dtlCol.filter(item=>item.thide=='N') " :key="index"
                        :prop="item.key"
                        :label="item.title"
                        show-overflow-tooltip
                        :align="item.align"  
                        :fixed="item.fix=='Y'" 
                        resizable                              
                        :sortable="item.sortable=='N'&&item.edcss!=='checkbox'"
                        :min-width="item.width">                    
                            <template slot-scope="scope">
                                <span   v-text="scope.row[item.key]" ></span>                   
                            </template>        
                    </el-table-column>  
                    <el-table-column
                        fixed="right"
                        :label="$LANG('0330', '操作')"
                        align="center"
                        width="135">
                        <template slot-scope="scope">
                            <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                            <el-link :disabled="saveFlag" @click="editRec(scope.row,scope.$index )" :underline="false"  ><span style="font-size:12px;margin-right:10px; ">{{ $LANG('1639', '编辑') }}</span></el-link>
                            <i class="iconfont icon-shanchu1" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                            <el-link :disabled="saveFlag " @click="delRec(scope.row,scope.$index )" :underline="false"  ><span style="font-size:12px; ">{{ $LANG('0131', '删除') }}</span></el-link>
                        </template>
                    </el-table-column>  
                </el-table>
                              
            </div>
 
        </el-dialog> 
        <el-dialog class="pub_dialog" v-dialogDrag   :visible.sync="addWin" width="550px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:36px;height:36px;font-size:15px;padding-left:5px;"><i class="iconfont icon-xuanze" style="margin-right:5px"></i>{{$route.meta.title}} ：{{ $LANG('0109', '明细资料') }}</span>
            </div> 
            <div style="display:flex;line-height:40px;height:45px">    
                <div style="font-size:12px;width:100px; ">{{ $LANG('0875', '生产订单') }}</div>
                <el-input   type="text" disabled v-model="v_addRow['ORDNO']" style="width:400px"></el-input> 
            </div>
            <div style="display:flex;line-height:40px;height:45px">    
                <div style="font-size:12px;width:100px;color:red">{{ $LANG('0055', '报工日期') }}</div>
                <el-date-picker :clearable="false" style="width:400px"   value-format="yyyy-MM-dd" v-model="v_addRow['DTTM']" type="date"  > </el-date-picker>              
            </div>
            <div style="display:flex;line-height:40px;height:45px">    
                <div style="font-size:12px;width:100px; ">{{ $LANG('0717', '工序名称') }}</div>
                <el-input   type="text" disabled v-model="v_jobnm" style="width:400px"></el-input> 
            </div>
            <div style="display:flex;line-height:40px;height:45px">    
                <div style="font-size:12px;width:100px;color:red">{{ $LANG('0054', '报工数量') }}</div>
                <el-input :placeholder="$LANG('0472', '数字框')" type="number" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"    v-model="v_addRow['QTY']" style="width:400px"> </el-input>
            </div>
            <div style="display:flex;line-height:40px;height:45px">    
                <div style="font-size:12px;width:100px;color:red">{{ $LANG('0251', '人数') }}</div>
                <el-input :placeholder="$LANG('0472', '数字框')" type="number" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"    v-model="v_addRow['STAFFNUM']" style="width:400px"> </el-input>
            </div>
            <div style="display:flex;line-height:40px;height:45px">    
                <div style="font-size:12px;width:100px; ">{{ $LANG('0294', '备注') }}</div>
                <el-input   type="text"   v-model="v_addRow['RMK']" style="width:400px"></el-input> 
            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px;;margin-top:15px  ">
                <span style="float:right">
                    <el-button type="info" size="small" icon="iconfont icon-shanchu" @click="addWin=false" style=" margin-left:30px;">{{ $LANG('0132', '取消') }}</el-button>
                    <el-button type="primary" size="small" icon="iconfont icon-chenggong" @click="saveRec" style=" margin-left:30px;">{{ $LANG('1638', '确定') }}</el-button>
                </span>
            </div>
        </el-dialog> 
 
        <el-dialog :visible.sync="loadWin" width="53px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
            <el-image  src="/assets/authorize/loading.gif" ></el-image>  
        </el-dialog>
        <VeColumnConfigDialog
            :visible="fieldSettingDialog.visible"
            :rows="fieldSettingDialog.rows"
            :loading="fieldSettingDialog.loading"
            :error="fieldSettingDialog.error"
            :locked-field-keys="fieldSettingDialog.lockedFieldKeys"
            :drag-group-field="fieldSettingDialog.dragGroupField"
            :language="$store.state.lang"
            @update:visible="fieldSettingDialog.visible = $event"
            @change="updateFieldSettingsDraft"
            @confirm="saveFieldSettingsDialog"
            @reset="resetFieldSettingsDialog"
            @close="closeFieldSettingsDialog"
        />
        <!-- 引用报表 -->
        <el-dialog  v-dialogDrag   :visible.sync="repDlg" width="550px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="6vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0059', '报表参数') }}</span>
            </div> 
            <rep-win v-bind:v_idno ="v_idno" v-bind:v_replist="v_replist" v-bind:v_corpid="v_corpid" @child-exit="repDlg=false" @child-sure="repShow"></rep-win>                
        </el-dialog> 
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="repWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0063', '报表预览') }}</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <iframe :src="repUrl" frameborder="0" style="width: 100%; height: 100%"></iframe>
            </div>
        </el-dialog>
        
        <ProcessMindMap
            v-if="processWin"
            :visible.sync="processWin"
            :order-row="v_repRow"
            :drawer="true"
            :full-height="true"
            :enable-node-add="true"
            :drawer-title="processMindMapTitle">
        </ProcessMindMap>
 
    </div>
</template>
<script>
import {getBaseData,getTabColOrData} from '../../api/user'; 
import { getDate} from '../../api/Select' 
import repWin from '../datamgt/repWin.vue'  
import ProcessMindMap from '@/components/ProcessMindMap/index.vue'
import createVeTableFieldSettingMixin from '@/utils/veTableFieldSettingMixin'
import VeColumnConfigDialog from '@/components/VeTable/VeColumnConfigDialog.vue'
export default {
    name:'order_process',
    mixins: [
        createVeTableFieldSettingMixin({
            settingFormId: '439546',
            fieldIdseq: '439546',
            fieldLstseq: '1',
            mainColumnKey: 'tabCol',
            tableColumnKey: 'vueCol',
            initColumnKey: 'initCol',
            tableRef: 'tableRef',
            lockedFieldKeys: ['SMPNO'],
            leftFixedColumnKeys: ['ORDNO'],
        })
    ],
    data () {
        return {
            repWin:false,
            repDlg:false,
            loadWin:false,
            v_query:{},
            v_cond:'',
            v_row:{},
            v_table:'',
            tableCol :[],
            v_key2 :'',
            v_value2 :'',
            dtlWin:false,
            qryCond:'',
            txtArr1:[],
            t_stfg:'N',
            v_bool:true,
            v_commit :true,
            promptWin:false,
            v_jobnm:'',
            loadingInstance: null,
            v_stfgrow:'',
            v_addRow:{},
            stfgSet:'ALL',
            delDtlArr:[],
            prompt:'',
            input_hold:this.$LANG('1670', '请输入内容...'),
            v_jobno:'',
            selparam:'ORDNO',
            txtparam:'',
       
            initCol:[],
            goPage:'',
            v_flag:'',
            tabData:[],
            cfmBool:false, //审核 权限
            addBool:false, //新增 权限
            editBool:false, //编辑权限
            appBool:false, //作废权限
 
            v_ordload:false,
            current:1,
            saveFlag:false,
            allList:[], //询价单集合
            pageIndex:1,
            startRowIndex:0,
            v_clntno:'',
            addWin:false,
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') , //员工公司ID
            v_url:'xuper_auth/getTableRecMany', //api请求路径    
            pageList: [50,500,1000],
            dataCount:0,
            pageCount:0,
            pageSize:50,
 
            tabCol:[],
            operArr:[],
            dtlData:[],
            dtlCol:[],
            qtyArr:[],
            oper:'like',
            v_key:'',
 
            clszArr:[],
       
            cltArr:[],
            v_usernm:this.$cookies.get('v_usernm'), //api 请求用户
            v_pct:0 ,
            repUrl:'',
            v_index:'',
            v_idno:'',
            v_replist:[],
            repArr:[],
            v_random:'',
  
            szArr:[],
            ordData:[],
 
            setCol:[],
            setKeyCol:[],      
            v_admin:this.$cookies.get('v_admin') ,//  
            columnHiddenOption: {
                // default hidden column keys
                defaultHiddenColumnKeys: [],
            },
            rowStyleOption: {
                clickHighlight: true,
                
            },
            cellStyleOption: {
                bodyCellClass: ({ row, column, rowIndex }) => {
                    return "table-body-cell-class1" 
                },
                headerCellClass: ({column, rowIndex }) => {
                    if (column.field=='#'){
                        return "table-head-cell-class2"
                    }else{
                        return "table-head-cell-class" 
                    }
                },
                footerCellClass: ({ row, column, rowIndex }) => {
                    return "table-foot-cell-class";
                },
            },
            virtualScrollOption: { enable: false },
            vueCol:[],
            v_inputrow:{},
            footerData:[], 
            v_repRow:{},
            processWin:false,
    
        }
    },
    components: {
        repWin,
        ProcessMindMap,
        VeColumnConfigDialog,
    },
    computed: {
        subHeight: function() {
            return (window.innerHeight - 158) + 'px';
        }, 
        dtlHeight: function() {
            return (window.innerHeight - 205) + 'px';
        }, 
        tabWidth: function() {
            return (window.innerWidth - 140) + 'px';
        },
        dtlTitle: function() {
            if (this.$store.state.lang === 'CN') {
                const titleArr = this.$LANG('0804', '生产制单： ，工序名称').split(' ')
                if (titleArr.length > 1) {
                    return titleArr[0] + this.v_addRow['ORDNO'] + '  ' + titleArr[1] + titleArr[0].slice(-1) + this.v_jobnm
                }
                return titleArr[0] + this.v_addRow['ORDNO'] + '  ' + this.$LANG('0717', '工序名称') + titleArr[0].slice(-1) + this.v_jobnm
            }
            return this.$LANG('0875', '生产订单') + ': ' + this.v_addRow['ORDNO'] + ' , ' + this.$LANG('0717', '工序名称') + ': ' + this.v_jobnm
        },
        processMindMapTitle: function() {
            const orderNo = (this.v_repRow && (this.v_repRow['ORDNO'] || this.v_repRow['IDNO'])) || ''
            return (orderNo ? orderNo + ' ' : '') + this.$LANG('', '生命周期')
        },
    },
    mounted () {
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','439546','V_USER_MOD_REP','').then(res=>{
            this.repArr =res.result
        })
        getBaseData(this.v_url+ '','CORPID',this.v_corpid,'','','V_ORD_JOBGP','').then(res=>{
            this.qtyArr =res.result
        })
        
        //操作符
        getBaseData('xuper_auth/getBaseData','PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        })         
         //用户权限表
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','439546','v_sys_user_priv','').then(res=>{                   
            if (this.v_admin==='N') { //表示有权限控制
                let row =res.result[0]
                if (row.ISADD==='N'){ //新增
                    this.addBool=true
                }if (row.ISUPD==='N'){ //修改
                    this.editBool=true
                }if (row.ISDEL==='N'){ //删除
                    this.delBool=true
                }if (row.ISCFM==='N'){ //审核
                    this.cfmBool=true
                }if (row.ISEXP==='N'){ //作废
                    this.appBool=true
                }
            }
        })    

    },
    destroyed() {
        this.loadingInstance.destroy()
    },
    created () {
        if (this.v_username){
            this.loadingInstance = this.$veLoading({
                target: document.querySelector("#loading-ordpro"),
                name: "wave",
            })
            this.getTabCol() //表列集合
            this.qryTabData() //询价单主数据   
  
            this.showkey()
        }else{
            let routeUrl = this.$router.resolve({
                path: '/',
                query: {lang:this.LANG },
            });
            window.open(routeUrl.href, '_self'); 
        }
    },
    methods: {
        processShow(row){
            const payload = {corpid:this.v_corpid,p_idseq:row['IDSEQ'],p_action:'SALE_NODE#'+row['LSTSEQ'],p_user: this.v_username}
            this.$axios({
                method: 'post',
                url:'/xuper_oss/call_package',
                data: payload,
            }).then(res=>{
                if (res.code!=='200'){
                    this.promptWin =true
                    this.prompt =res.result
                }else{
                    this.v_repRow =JSON.parse(JSON.stringify(row))
                    this.processWin =true
                }
            })
        },
        repShow(row){
            if (!row['REPNO']){
                this.promptWin =true
                this.prompt =this.$LANG('1678', '请选择报表')
            }else{
                this.repWin =true
                this.repDlg =false
                this.repUrl =this.$store.state.repUrl+ row['REPNO']+'&p_corpid='+row['CORPID']+'&p_idseq='+this.v_repRow['IDSEQ']+'&p_lstseq='+this.v_repRow['LSTSEQ']
            }
        },
        inputChg(e,column){
            this.v_inputrow[column]=e.target.value
            this.v_row[column] =e.target.value
            this.qryTabData()
        },
        //页号改变
        pageNumberChange(pageIndex) {
            this.pageIndex = pageIndex
            this.changePage(pageIndex)
        },
        pageSizeChange(pageSize) {
            this.pageIndex = 1
            this.pageSize = pageSize
            this.changePage(this.pageIndex)
        },

        showQty(row,v_jobno){
            let v_qty ='',v_pct=0
            this.qtyArr.some(item=>{
                if (item['IDSEQ']==row['IDSEQ']&&item['LSTSEQ']==row['LSTSEQ']&&item['CORPID']==this.v_corpid&&item['JOBNO']==v_jobno){
                    v_qty= item['QTY']
                    v_pct =item['PCT']
                }
            })
            return {QTY:v_qty,PCT:v_pct}
        },
        stfgChg(){
            this.getTabList('')
        },
        //合并表 单元格
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
            if (column.property=='clnm') {
                // 获取当前单元格的值
                const currentValue = row[column.property];
                // 获取上一行相同列的值
                const preRow = this.ordData[rowIndex - 1];
                const preValue = preRow ? preRow[column.property] : null;
                // 如果当前值和上一行的值相同，则将当前单元格隐藏
                if (currentValue === preValue) {
                    return { rowspan: 0, colspan: 0 };
                } else {
                    // 否则计算当前单元格应该跨越多少行
                    let rowspan = 1
                    for (let i = rowIndex + 1; i < this.ordData.length; i++) {
                        const nextRow = this.ordData[i];
                        const nextValue = nextRow[column.property];
                        if (nextValue === currentValue) {
                            rowspan++;
                        } else {
                            break;
                        }
                    }
                    return { rowspan, colspan: 1 };
                }
            }
        },
        copyData() {
            const tableContainer = this.$refs['refdtl'].$el
            // 移除固定列
            const fixedColumns = tableContainer.querySelectorAll('.el-table__fixed')
            fixedColumns.forEach(column => {
                column.remove()
            })
            const selection = window.getSelection()
            const range = document.createRange()
            selection.removeAllRanges()
            range.selectNode(tableContainer)
            selection.addRange(range)
            document.execCommand('copy')
            selection.removeAllRanges()
            //恢复固定列
            fixedColumns.forEach(column => {
                tableContainer.appendChild(column)
            })
            this.$message.success(this.$LANG('1824', '表格内容已复制到剪贴板'))
        },
 
        addRec(){            
            this.addWin =true

            this.v_addRow['DTTM'] =getDate('day')
            this.v_addRow['RMK']=''
            this.v_addRow['QTY']=''
            this.v_flag ='create'
        },
        //工序明细查看
        procShow(row,v_arr){
            this.v_addRow=JSON.parse(JSON.stringify(row))
      
            this.v_jobnm =v_arr[0]
            this.v_jobno =v_arr[1]
            this.dtlWin =true
            this.getDtlist(this.v_addRow['IDSEQ'],this.v_addRow['LSTSEQ'], this.v_jobno)
        },
        getFootSum(){
            let v_foot ={}
            const targetKeys = ['PCQTY',  'QTY' ]
            // 初始化累加器对象
            const initialAcc = targetKeys.reduce((acc, key) => {
                acc[key] = 0
                return acc
            }, {})
            // 单次 reduce 计算所有总和
            const totals = this.tabData.reduce((acc, cur) => {
                targetKeys.forEach(key => {
                    // 累加当前 key 的值，处理 undefined/null 情况
                    acc[key] += Number(cur[key]) || 0
                });
                return acc
            }, initialAcc)
            // 格式化并赋值
            targetKeys.forEach(key => {
                const val = totals[key];
                v_foot[key] = val > 0 ? val.toLocaleString() : '';
            })
            let v_obj =Object.assign({
                    rowKey: 0,
                    index: this.$LANG('0280', '合计'),
                }, v_foot)
            this.footerData =[  v_obj ]
        } , 
 
        getDtlSummary(param){
            const {columns ,data}=param
            const sums=[]
            columns.forEach((column,index)=>{
                if (index===0){
                    sums[index]=this.$LANG('0280', '合计')
                    return
                }
                const values =this.dtlData.map(item=>Number(item[column.property]));
                if( column.property==='QTY'){
                    let v_sum =values.reduce((prev,curr)=>{ //为数组中每一个元素依次执行回调函数
                        const value=Number(curr)
                        if(!isNaN(value)){
                            return Number(Number(prev) +Number(curr) )
                        }else{
                            return prev
                        }
                    },'')
                    if (v_sum){
                        sums[index] =v_sum.toLocaleString()
                    }else{
                        sums[index]=''
                    }
                }
            })
            return sums
        },
 
        imgPreview(path){
           
            window.open(path, '_blank');
        },
        editRec(row,index){
            this.addWin =true
            this.v_addRow =JSON.parse(JSON.stringify(row))
            this.v_jobno=row['JOBNO']
            this.v_jobnm =row['JOBNM']
            this.v_flag ='edit'
        },
        delRec(row,index){
            this.$confirm(this.$LANG('1594', '你确定要删除此行记录吗')+'?',this.$LANG('1442', '提示'),{
                confirmButtonText: this.$LANG('1638', '确定'),
                cancelButtonText:this.$LANG('0132', '取消'),
                customClass:'messageBox',
                showClose:false,
                type:'info',
            }).then(()=>{
                this.$axios({   
                    method: 'post',
                    url:'xuper_auth/delTabRec',
                    data: {p_key:'idseq',p_value:row['IDSEQ'],p_key2:'lstseq',p_value2:row.LSTSEQ,p_key3:'itmseq',p_value3:row.ITMSEQ, p_table:'ORD_JOBITM' },
                }).then(res=>{
                    this.dtlData.splice(index,1)
                    // 赋值到 工序数量
                    this.$axios({   
                        method: 'post',
                        url:'xuper_auth/getBaseData',
                        data: { p_key:'corpid', p_value:this.v_corpid, p_table:'V_ORD_JOBGP' },
                    }).then(res=>{ 
                        this.qtyArr =res.result
                        this.showQty(this.v_addRow,this.v_jobno)
                    })
                })
            }).catch(()=>{})
        },
        saveRec(){            
            if (!this.v_addRow['DTTM']){
                this.promptWin =true
                this.prompt =this.$LANG('0055', '报工日期')+this.$LANG('2051', '不能为空')
            }else if (!this.v_addRow['QTY']){
                this.promptWin =true
                this.prompt =this.$LANG('0054', '报工数量')+this.$LANG('2051', '不能为空')
            }else if (!this.v_addRow['STAFFNUM']){
                this.promptWin =true
                this.prompt =this.$LANG('2099', '报工人数')+this.$LANG('2051', '不能为空')
            }else{
                let v_obj ='' 
                if (this.v_flag =='create'){
                    v_obj = {IDSEQ:this.v_addRow['IDSEQ'],LSTSEQ:this.v_addRow['LSTSEQ'],ITMSEQ:'',ORDNO:this.v_addRow['ORDNO'],JOBNO:this.v_jobno,
                            JOBNM:this.v_jobnm,DTTM:this.v_addRow['DTTM'],QTY:this.v_addRow['QTY'],RMK:this.v_addRow['RMK'] ,STAFFNUM:this.v_addRow['STAFFNUM'] }  
                }else{
                    v_obj = {IDSEQ:this.v_addRow['IDSEQ'],LSTSEQ:this.v_addRow['LSTSEQ'], JOBNO:this.v_jobno,JOBNM:this.v_jobnm,DTTM:this.v_addRow['DTTM'],
                            QTY:this.v_addRow['QTY'],RMK:this.v_addRow['RMK'],ITMSEQ:this.v_addRow['ITMSEQ'],STAFFNUM:this.v_addRow['STAFFNUM'] }  
                }
 
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/tableBodySave2',
                    data: {p_json:JSON.stringify(Object.assign(v_obj)), p_table:'ORD_JOBITM' },
                }).then(res=>{
                    if (res.code=='200'){
                        this.addWin =false
                        this.getDtlist(this.v_addRow['IDSEQ'],this.v_addRow['LSTSEQ'], this.v_jobno)
           
                        // 赋值到 工序数量
                        this.$axios({   
                            method: 'post',
                            url:'xuper_auth/getBaseData',
                            data: { p_key:'corpid', p_value:this.v_corpid, p_table:'V_ORD_JOBGP' },
                        }).then(res=>{ 
                            this.qtyArr =res.result
                            this.showQty(this.v_addRow,this.v_jobno)
                        })
                    }else{
                        if (res.result.indexOf('ORA-00001')>-1){
                            this.prompt =this.$LANG('1874', '已存在同日期下的记录,请核查')
                        }else{
                            this.prompt =res.result
                        }
                        this.promptWin =true
                        
                    }
                })
            }
        },
        //split-button 下拉选项
        dropSel(val){
            if (val =='expdata'){ //导出数据
                //导出
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/report/GenExcel',
                    data: {p_idseq:'439546',p_lstseq:'1',p_json:JSON.stringify(this.allList),p_action:'生产进度'},
                    responseType:'blob' //关键，声明响应类型为二进制流
                }).then(response=>{ 
                    // 从响应头解析后端设置的文件名
                    // 创建Blob对象并触发下载  创建下载链接
                    const blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(blob)
                    link.download = this.$LANG('0877', '生产进度')+'_'+getDate('full')+'.xls'
                    link.click()
                    URL.revokeObjectURL(link.href)

                })
                
            }else if (val =='fldset'){ //字段设置
                this.openFieldSettingsDialog().catch(error => {
                    this.promptWin =true
                    this.prompt =error.message || this.$LANG('1225', '字段显示设置')
                })
            }  
        },
        sortChange(params){
            let v_key=params.key ,v_edcss=''
            if (this.v_sort =='asc'){
                this.v_sort ='desc'
            }else if (this.v_sort =='desc'){
                this.v_sort ='asc'
            } 
            this.tabCol.some(item=>{
                if (item['key']==v_key){
                    v_edcss =item['edcss']
                }
            })            
            this.tabData.sort((a, b) => {
                if (v_edcss =='number' ){
                    if (this.v_sort =='asc'){ //a == null ? -1 : b == null ? 1 : 0
                        return a[v_key] == null ? -1 : b[v_key] == null ? 1 :   a[v_key] -b[v_key]
                    }else if (this.v_sort =='desc'){
                        return b[v_key] == null ? -1 : a[v_key] == null ? 1 :  b[v_key] -a[v_key]
                    }else{
                        return 0
                    }
                }else{
                    let nameA = a[v_key]==null?'':a[v_key].toUpperCase() 
                    let nameB = b[v_key]==null?'':b[v_key].toUpperCase()  
                    if (this.v_sort =='asc'){
                        return nameA == null ? -1 : nameB== null ? 1 :  nameA > nameB ? -1 : 1
                    }else{
                        return nameA == null ? 1 : nameB== null ? -1 : nameA > nameB ? 1 : -1
                    }
                }
            })
        },
        //禁止 键盘上、下键改变值
        showkey() {
            document.onkeydown = function () {
                if (window.event.keyCode === 38 || window.event.keyCode === 40) {
                    window.event.returnValue = false;
                }
            }
        },
        selChg(val){
            this.tabCol.some(it=>{
                if (it['key']== val){
                    if (it['edcss']=='date'){
                        this.v_bool =false
                    }else{
                        this.v_bool =true
                    }
                }
            })
            this.txtArr1=[]
            this.txtparam1=''
        },
 
        //字段查询
        inputQry(){
            let v_cond ='' ,v_edcss=''
            Object.keys(this.v_row).forEach(item=>{
                if (this.v_row[item] ){
                    this.tabCol.some(it=>{
                        if (it['key']== item){
                            v_edcss =it['edcss']
                        }
                    })
                    if (v_cond ){
                        if (v_edcss =='number'){
                            v_cond =v_cond +' and '+item+'>='+  this.v_row[item] 
                        }else{
                            v_cond =v_cond +' and lower('+item+') like \'%'+ (this.v_row[item]).toLowerCase().trim()+'%\''
                        }
                    }else{
                        if (v_edcss =='number'){
                            v_cond = ' and '+item+'>='+  this.v_row[item] 
                        }else{
                            v_cond = ' and lower('+item+') like \'%'+ (this.v_row[item]).toLowerCase().trim()+'%\''
                        }
                    }
                }
            })
            this.getTabList(v_cond)
        },
        //工序明细过滤查询
 
        rowShow(){
            Object.keys(this.v_row).forEach(item=>{
                this.v_row[item] =''
            })
            this.v_inputrow={}
            this.getTabList('')
        } ,
 
        getRowKey(row){
            return row.index
        },
   
        tabRowClass({row,rowIndex}){  //为 table数据添加 index 字段
            row.index =rowIndex
            if (row['ordstfg']=='ok1') {  //完成
                return 'green-row';
            } 
        },
        repBtn(row){
             this.repDlg =true
             this.v_repRow =JSON.parse(JSON.stringify(row))
             this.v_idno =row['ORDNO']
             this.v_replist =this.repArr
        },
        //状态查询
        qryTabData(){
            let cond_='' ,v_edcss='',v_edcss2=''
            if (this.selparam){ //列1
                this.tabCol.some(item=>{
                    if (item['key']==this.selparam){
                        v_edcss =item['edcss']
                    }
                })
                if (v_edcss =='date'){
                    if (this.txtArr1 )
                    cond_=cond_+' and '+this.selparam+' between \'' + this.txtArr1[0]+'\' and \''+ this.txtArr1[1]+'\''
                }else {
                    if (this.oper==='like'){
                        v_cond=v_cond+' and  '+this.selparam+'  like  \'%' + this.txtparam+'%\' '
                    } else{
                        if (this.txtparam){
                            if (v_edcss=='number'){
                                v_cond=v_cond+' and  '+this.selparam  +this.oper+ this.txtparam
                            }else {
                                v_cond=v_cond+' and  '+this.selparam  +this.oper+' \''+this.txtparam+'\' '
                            }
                        }
                    }   
                }
            }
 
            let v_cond =''
            Object.keys(this.v_row).forEach(item=>{
                if (this.v_row[item] ){
                    this.tabCol.some(it=>{
                        if (it['key']== item){
                            v_edcss =it['edcss']
                        }
                    })
                    if (v_cond ){
                        if (v_edcss =='number'){
                            v_cond =v_cond +' and '+item+'>='+  this.v_row[item] 
                        }else{
                            v_cond =v_cond +' and lower('+item+') like \'%'+ (this.v_row[item]).toLowerCase().trim()+'%\''
                        }
                    }else{
                        if (v_edcss =='number'){
                            v_cond = ' and '+item+'>='+  this.v_row[item] 
                        }else{
                            v_cond = ' and lower('+item+') like \'%'+ (this.v_row[item]).toLowerCase().trim()+'%\''
                        }
                    }
                }
            })
            this.getTabList(cond_+v_cond)
        }, 
 
        //表格页面导航
        changePage(index){
            var _start = ( index - 1 ) * this.pageSize;
            var _end = index * this.pageSize
            this.current =index
            this.tabData = this.allList.slice(_start,_end);
        },
 
        //初始化查询页条数
        initPage(){
            //产品明细
            this.dataCount =this.allList.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allList.length < this.pageSize){
                this.tabData = this.allList          
            }else{
                this.tabData =this.allList.slice(0,this.pageSize) //返回选定元素的子数组，不包含结尾元素
            }
 
        },
        //查询界面
        getTabList(cond){    
            let vm =this
            this.loadingInstance.show() 
            let v_cond='' 
            if (this.t_stfg =='N'){ //仓存=0
                v_cond =' and stfg =\'N\''
            }else if (this.t_stfg =='Y'){
                v_cond =' and stfg=\'Y\''
            }
            getTabColOrData(this.v_url,'V_SALEORD_PROC','','','corpid',this.v_corpid,'','',cond+v_cond +' order by '+this.selparam+' desc').then((res) => { 
                if (res.code=='200') {
                    this.allList =res.result 
                    this.$nextTick(() => { //有固定列时 查询后重新布局
                        this.loadingInstance.close() 
                        this.getFootSum() //汇总
                    }) 
                    this.initPage() 
                }else{
                    this.promptWin =true
                    this.prompt =res.result
                    this.loadingInstance.close() 
                }
            })
        },
        //明细数据
        getDtlist(v_idseq,v_lstseq,v_jobno ){
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: { p_key:'idseq', p_value:v_idseq,p_key2:'jobno', p_value2:v_jobno, p_table:'V_ORD_JOBITM',p_cond:' and lstseq='+v_lstseq+' order by dttm desc' },
            }).then(res=>{ 
                if (res.code=='200'){
                    this.dtlData =res.result
                    this.$nextTick(()=>{
                        this.$refs['refdtl'].doLayout()
                    })
                }else{
                    this.promptWin =true
                    this.prompt =res.result
                }
            })
        },
        //获取表列头字段  v-enter-number
        getTabCol(){
            var vm=this
            this.vueCol =[]
            this.tabCol =[]
            this.dtlCol =[]
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','439546','lstseq','1','','',' order by sortby,lstseq' ).then((res) => {
                this.initCol =res.result
                return this.loadInitialFieldSettings().then(() => res)
            }).then((res) => {
                this.vueCol =[]
                this.tabCol =[]
                // Keep the fixed ORDNO slot from metadata; the mixin applies user order after columns are built.
                const mainFields =this.initCol.slice()
                for (let k=0; k<mainFields.length; k++){
                    const rowField =mainFields[k]
                    vm.tabCol.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(rowField, vm.$store.state.lang),
                        key: rowField.key ,
                        align: rowField.align,
                        width: rowField.width,
                        thide:rowField.THIDE,
                        fhide:rowField.FHIDE,
                        edcss:rowField.EDCSS,
                        disabled:rowField.DISABLED,
                        dotnum:rowField.DOTNUM,
                        holder:rowField.HOLDER,
                        sortable:rowField.SORTABLE,
                        fix:rowField.ISFIX,
                        tip:rowField.ISTIP,
                    })
                    let itcol =rowField
                    if (itcol['THIDE']=='N'){
                        let v_obj ={   //向数组的开头 添加序列号
                            field:itcol['key'] ,
                            title: vm.$translate.getColTitle(itcol, vm.$store.state.lang),
                            key: itcol['key']  ,
                            type:itcol.EDCSS=='checkbox'?'check':itcol.EDCSS,
                            align: itcol.align,                                
                            width: Number(itcol.width),
                            thide:itcol.THIDE,
                            fhide:itcol.FHIDE,
                            sortable:false,
                            fixed:itcol.key=='ORDNO'?'left':'',
                            renderHeaderCell: ({column}, h) => {
                                if (column.key=='ORDSTFG') {
                                    return (                              
                                        <div >                   
                                            <div style="margin-top:3px;display:flex;white-space: nowrap;  " >
                                                <el-link underline={false} on-click={()=>{this.sortChange(column)} } style="font-size:12px;color:#03274b;font-weight:700">{column.title}</el-link>                                            
                                            </div> 
                                            <div style="display:flex" >
                                                <el-select placeholder="" size="mini" style="width:100%;background:white;height:28px;margin-top:1px" v-model={this.v_row[column.key]}   on-change={()=>{this.qryTabData()}}>
                                                    <el-option  value="Y" label={this.$LANG('1976', '已审核')} ></el-option>
                                                    <el-option  value="P"  label={this.$LANG('1961', '审核中')} ></el-option>
                                                    <el-option  value="K"  label={this.$LANG('1982', '已确认')} ></el-option>
                                                    <el-option  value="N"  label={this.$LANG('2005', '未审核')} ></el-option>
                                                </el-select>                                                          
                                            </div>
                                        </div>                                   
                                    )
                                } else{
                                    if (itcol.EDCSS =='number') {
                                        return (                              
                                            <div >
                                                <div style="margin-top:3px;display:flex;white-space: nowrap; " >
                                                    <el-link underline={false} on-click={()=>{this.sortChange(column)} } style="font-size:12px;color:#03274b;font-weight:700; ">{column.title}</el-link>                                            
                                                </div>  
                                                <div style="display:flex">
                                                    <select  style="width:60px;background:white;height:28px;margin-top:1px" value={this.v_inputrow[`#OPER`+column.key]} on-change={(e)=>{this.inputChg(e,`#OPER`+column.key)}}>
                                                        <option    value="=" style="height:30px;line-height:30px">=</option>
                                                        <option    value=">" style="height:30px;line-height:30px">&gt;</option>
                                                        <option    value="<" style="height:30px;line-height:30px">&lt;</option>
                                                        <option    value="!=" style="height:30px;line-height:30px">!=</option>
                                                    </select>
                                                    <el-input placeholder="" disabled={itcol.EDCSS=='image'} v-model={this.v_row[column.key]} on-change={()=>this.qryTabData()} style="padding:0px;margin-top:1px;width:100%;height:28px; " size="mini"></el-input>
                                                </div>
                                            </div>                                   
                                        )
                                    }else{
                                        return (                              
                                            <div >
                                                <div style="margin-top:3px;display:flex;white-space: nowrap; " >
                                                    <el-link underline={false} on-click={()=>{this.sortChange(column)} } style="font-size:12px;color:#03274b;font-weight:700; ">{column.title}</el-link>                                            
                                                </div>  
                                                <div style="display:flex">
                                                    <el-input placeholder="" disabled={itcol.EDCSS=='image'} v-model={this.v_row[column.key]} on-change={()=>this.qryTabData()} style="padding:0px;margin-top:1px;width:100%;height:28px; " size="mini"></el-input>
                                                    
                                                </div>
                                            </div>                                   
                                        )
                                    }
                                }
                            },
                            disabled:itcol.DISABLED,
                            ellipsis: { showTitle: true, },
                            renderBodyCell: ({row,column,rowIndex},h) => {
                                let  rowVal =row[itcol['key'] ]
                                if (itcol.EDCSS=='image' ){
                                    return ( 
                                        <el-image fit="scale-down"  style="width:100%;height:58px; " src={rowVal} preview-src-list={[rowVal]}>
                                            <div   slot="error" ><i class="el-icon-picture-outline"></i></div>
                                        </el-image>
                                    )
                                } else if (column.key=='ORDSTFG') {                         
                                    if (row[itcol['key']] =='Y'){
                                        return (<el-tag   size="mini" type="success" effect="dark">{this.$LANG('1976', '已审核')}</el-tag> )
                                    }else if (row[itcol['key']] =='P'){
                                        return (<el-tag   size="mini" type="warning" effect="dark">{this.$LANG('1961', '审核中')}</el-tag> )
                                    }else if (row[itcol['key']] =='N'){
                                        return (<el-tag   size="mini" type="info" effect="dark">{this.$LANG('2005', '未审核')}</el-tag> )
                                    }else if (row[itcol['key']] =='K'){
                                        return (<el-tag   size="mini" type="danger" effect="dark">{this.$LANG('1982', '已确认')}</el-tag> )
                                    }else {
                                        return (<el-tag   size="mini" type="danger" effect="dark">{this.$LANG('1964', '已作废')}</el-tag> )
                                    }                                          
                                }else if (column.key=='ORDNO') { 
                                    return (                                           
                                        <el-link  underline={false} on-click={()=>{this.repBtn( row)}}><span style=" border-bottom:1px solid red;font-size:13px;;font-weight:700  " title={rowVal}>{rowVal}</span> </el-link>    
                                    )
                                }else if (column.key=='OPER') { 
                                    return (                                           
                                        <el-link  underline={false} on-click={()=>{this.processShow( row)}}><span style=" border-bottom:1px solid red;font-size:13px;;font-weight:700  " title={this.$LANG('', '查看产品生命周期')}>{this.$LANG('0139', '查看')}</span> </el-link>
                                    )
                                }else if (column.key=='JOBPROC') {  // 
                                    let v_arr =row['JOBPROC'].split(',') ,v_row={}  
                                  
                                        v_arr.forEach((item, index) => {  
                                            v_row[index] =<div style=" width:140px;cursor:pointer;background:#D2E9FF;height:55px;margin-right:8px" on-click={()=>{this.procShow(row,item.split('#'))}} >
                                                                <div title={item.split('#')[0]} style="line-height:18px;height:18px;text-overflow: ellipsis;overflow: hidden;white-space: nowrap;border-left:2px solid #409eff;padding-left:2px">{item.split('#')[0]}</div>
                                                                <div  style="line-height:18px;height:18px;text-overflow: ellipsis;overflow: hidden;white-space: nowrap;border-left:2px solid #409eff;padding-left:2px;margin-top:1px">{this.$LANG('', '完工数量')}：{this.showQty(row,item.split('#')[1])['QTY']}</div>
                                                                <div  style="line-height:18px;height:18px;  margin-top:1px">
                                                                    <el-progress  percentage={this.showQty(row,item.split('#')[1])['PCT']} stroke-width={5}  ></el-progress>
                                                                </div>
                                                            </div>  
                                        })
                                        return ( <div style="overflow-x:auto;overflow-y:hidden;display:flex;height:65px;">
                                                    {v_row[0]}{v_row[1]} {v_row[2]}{v_row[3]}{v_row[4]}{v_row[5]}{v_row[6]}{v_row[7]}{v_row[8]}{v_row[9]}
                                                    {v_row[10]}{v_row[11]} {v_row[12]}{v_row[13]}{v_row[14]}{v_row[15]}{v_row[16]}{v_row[17]}{v_row[18]}{v_row[19]}
                                                    {v_row[20]}{v_row[21]} {v_row[22]}{v_row[23]}{v_row[24]}{v_row[25]}{v_row[26]}{v_row[27]}{v_row[28]}{v_row[29]}
                                                    {v_row[30]}{v_row[31]} {v_row[32]}{v_row[33]}{v_row[34]}{v_row[35]}{v_row[36]}{v_row[37]}{v_row[38]}{v_row[39]}
                                                    {v_row[40]}{v_row[41]} {v_row[42]}{v_row[43]}{v_row[44]}{v_row[45]}{v_row[46]}{v_row[47]}{v_row[48]}{v_row[49]}
                                                    {v_row[50]}{v_row[51]} {v_row[52]}{v_row[53]}{v_row[54]}{v_row[55]}{v_row[56]}{v_row[57]}{v_row[58]}{v_row[59]}
                                                </div> 
                                        )
                                    // }else{
                                    //     return (
                                    //         <div style="text-align:center;margin-top:20px">
                                    //             <el-tag  size="medium" type="danger" effect="dark">树状BOM未有工序 或 还未维护好产品树状BOM</el-tag>
                                    //         </div>
                                    //     )
                                    // }
                                } else if (itcol.EDCSS=='checkbox' ) {                         
                                    if (row[itcol['key']] =='Y'){
                                        return (<el-tag   size="mini" type="success" effect="dark">{this.$LANG('2047', '是')}</el-tag> )
                                    }else {
                                        return (<el-tag   size="mini" type="info" effect="dark">{this.$LANG('2044', '否')}</el-tag> )
                                    }                                          
                                }else{
                                    return row[itcol['key'] ]
                                }
                                
                            },                                
                        }
                        this.vueCol.push(v_obj)
                    }
                }
                // 分组 字段
                let v_rownum ={
                    field: "index",
                    key: "rownum",
                    title: this.$LANG('0310', '序号'),
                    width: 55,
                    align: "center",
                    fixed:"left", 
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (<span style="color:#1890ff;">
                            {rowIndex + this.startRowIndex + 1}
                        </span> )
                    },
                    renderHeaderCell: ({column}, h) => {
                        return (  
                            <div >
                                <div style="margin-top:3px">{column.title}</div>
                                <el-link on-click={()=>{this.rowShow()}} style="font-size:12px;color:#404eff;height:30px"> 
                                    <el-tooltip content={this.$LANG('0852', '清除条件')} effect="light">
                                        <i class="iconfont icon-shanchu1"  ></i>
                                    </el-tooltip>
                                </el-link>
                            </div>
                        )
                    },
                }
                this.vueCol.unshift(v_rownum) 
                this.applyFieldSettingRows()
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','439546','lstseq','2','','',' order by sortby,lstseq' ).then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.dtlCol.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                        key: res.result[k].key ,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM, 
                        holder:res.result[k].HOLDER,
                        sortable:res.result[k].SORTABLE,
                        fix:res.result[k].ISFIX,
                        tip:res.result[k].ISTIP,
                    })
                }
 
            })
 
        },
    }
}
</script>
<style scoped lang="less">
    .active { 
        color: #389;
        border-bottom:3px solid #cc0000;
        margin-right:2px;
    }
    .oneMenu{
        display:flex;
        flex-direction:column;
        line-height:25px;
        background:white;
        margin-top:3px;
        font-size:13px;
        font-weight: 600;
    }
    .oneMenu:hover{
        cursor: pointer;
        color:#cc0000;
        background:#f7f8f9;
        font-weight:700;
    }
    .percent_box {
        position: relative;
        text-align: center;
        width: 50px;
        margin-top:10px;
    }
    
    .text_box {
        position: absolute;
        top: 42%;
        left: 50%;
        color:red;
        transform: translate(-50%, -50%);
    }
    .custom-button {
      background: rgb(107, 104, 104);
      font-weight:600;
      font-size:14px;
      color:#cc0000 !important;
      border-radius: 4px 4px 4px 4px;
    }
    .custom-button:hover {
     // background: rgb(107, 104, 104);//rgb(248, 230, 230) !important;
      font-weight:600;
      font-size:14px;
      color:#389 !important;
      border-radius: 4px 4px 4px 4px;
    }
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 0 auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
</style>
<style lang="less">
    .el-table__body tr.current-row > td {
        background-color: #F1e1ff !important;
    } 
    .percent  svg path:nth-child(1) {
        stroke: #ccc;
    }
    .percent2  svg path:nth-child(1) {
        stroke: red;
    }
    .percent2 .el-progress__text {
        color: red;
        font-size: 14px !important;
    }
    .table-foot-cell-class {
        font-size: 12px !important;
        color: #03274b !important;
        background: #b2d3fa !important;
        font-weight:700 !important;
        padding: 2px !important;
        line-height: 25px !important;
        text-align:left !important;
        height: 15px !important;
   
    }
    .table-head-cell-class {
        font-size: 12px !important;
        color: #03274b !important;
        background: #e2e6eb !important;
        font-weight:700 !important;
        padding:0px !important;
        padding-top:4px !important;
        text-align:center !important;
        border-width: 1px !important;
        border-color: #808695 !important;
    }
    .table-head-cell-class2 {
        font-size: 12px !important;
        color: rgb(134, 4, 4) !important;
        background: #e2e6eb !important;
        font-weight:700 !important;
        border-width: 1px !important;
        border-color: #808695 !important;
        padding:6px !important;
    }
    .table-body-cell-class1 {
        font-size: 12px !important;
        color: black !important;
        border-width: 1px !important;
        padding:2px !important;
        border-color: #808695 !important;
    }
    .percent .el-progress__text {
        color: #409eff;
        font-size: 12px !important;
    }
    //圆环里面的字体颜色 设置字体样式
    
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-range-separator {
        width: 20px !important;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px;
            color:rgb(11, 11, 59);
            font-size:12px;
            background:rebeccapurple; 
        }
        td {
            padding: 5px ;
            font-size:11px;
        } 
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    //.el-dialog__headerbtn i { background:white;font-size: 20px;  }
    .el-table .default-row {
        color:black;
    }
    .el-table .cancel-row {
        color: #e00e66;
    }
    .el-table .green-row  {
        color: green;
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb;
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
